import { render, staticRenderFns } from "./CapillaryRiseViz.vue?vue&type=template&id=3b78bed7&scoped=true"
import script from "./CapillaryRiseViz.vue?vue&type=script&lang=js"
export * from "./CapillaryRiseViz.vue?vue&type=script&lang=js"
import style0 from "./CapillaryRiseViz.vue?vue&type=style&index=0&id=3b78bed7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b78bed7",
  null
  
)

export default component.exports